<template>
    <label class='checkbox-container'>
        <input type='checkbox'
               :value='inputKey'
               :checked='value'
               :required="required"
               :disabled="readonly"
               @input='emitInput'>

        <span class='checkbox'></span>

        <div class='checkbox-inner'>
            {{ label }}
        </div>
            <input-tip class="input-tip" v-if="tip" :tip="tip" />
    </label>
</template>

<script>
import AutoFieldMixin from '../../mixins/AutoField'
import InputTip from './InputTip'

export default {
  name: 'Checkbox',
  mixins: [AutoFieldMixin],
  components: {
    InputTip
  },
  props: {
    inputKey: {
      type: String,
      required: false
    },
    value: {
      default: false,
      type: Boolean
    },
    label: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      default: false
    },
    tip: {
      type: String
    },
    readonly: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    isValueTypeValid() {
      return typeof this.value === 'boolean'
    },
    defaultValue() {
      return false
    }
  },
  methods: {
    valueToSendFromEvent(e) {
      return e.target.checked
    },
    valueIsEmpty() {
      return false
    }
  }
}
</script>

<style lang="sass" scoped>
    .checkbox-container input[type='checkbox']
        opacity: 0
        position: absolute
        top: gridSteps(2)
        left: 0
        height: 1px
        width: 1px

    .checkbox-container
        display: flex
        justify-content: flex-start
        position: relative
        padding-left: gridSteps(3)
        margin-bottom: gridSteps(1)
        cursor: pointer
        text-align: left
        user-select: none

    .checkbox
        background: white
        border-radius: 5px
        border: 1px solid $grey
        height: gridSteps(2)
        width: gridSteps(2)
        position: absolute
        left: 0
        top: gridSteps(0.5)
        transition: 400ms

    .checkbox:after
        content: url("../../assets/img/icons/check.svg")
        display: block
        width: gridSteps(1)
        height: gridSteps(1)
        position: absolute
        top: pxToRem(-7px)
        left: pxToRem(2px)
        opacity: 0

    .checkbox-container input:checked ~ .checkbox:after
        opacity: 1

    .checkbox-inner
        position: relative

    .input-tip
        margin-top: gridSteps(0.5)
        margin-left: gridSteps(1)
        i
            line-height: 24px

</style>
